import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";


import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolume";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import { CaseListingType, ProvidersObject, StatisticsApiResponse } from "./types";
import CustomComponentBarChart from "src/components/manufacturer/customComponentBarChart";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CaseDetail from "src/components/manufacturer/caseDetail";
import CustomProviderPractice from "src/components/manufacturer/customProviderPractice";
import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import { TerritoriesSearchProps } from "src/components/manufacturer/territoriesFilter/types";
import { AuthContext } from "src/context/authContext";




const Territory: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  const {userData} = useContext(AuthContext);

  const [queryParams, changeQueryParams] = useState<TerritoriesSearchProps>({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter_type: searchParams.get("filter_type") || "",
    //time: searchParams.get("time") || "",
    type:   searchParams.get("type") ||"territories" ,
    role :userData?.ref_type || searchParams.get("role") || "",
    id:     Number(searchParams.get('id')) ||userData?.id || 0,
    search_str : searchParams.get('search_str') || "",
    str : searchParams.get('str') || "",
    // soc_value: searchParams.get("soc_value") || "",
    // drug_id: searchParams.get("drug_id") || "",
    // user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
  });

  useLayoutEffect(()=>{
      setLoader()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: TerritoriesSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        //time: "",
        type: "territories" ,
        role:  userData?.ref_type || searchParams.get("role") || "",
        id:  userData?.id || Number(searchParams.get('id')) ||  0,
        search_str : searchParams.get('search_str') || "",
        str : searchParams.get('str') || "",

      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = (period: string) => {
    const updatedQueries = {
      ...queryParams,
      period,
    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  const getStatisticsDataWithLatestParams = () => {
    getStatsData({}, {}, queryParams);
  }

  return (
    <div className="container-fluid overflow-auto pt-3">

      <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor={"black"} />

      {statisticsData && (
        <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />
      )}
      {statisticsData && (
        <CaseVolume StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} />
      )}
      {statisticsData && (
        <CustomComponentBarChart StatisticsObjectType={statisticsData.data} />
      )}
      {statisticsData && (
        <CustomPieChart pieChartObject={statisticsData.data.top_payors} title="Top 10 Payors" />
      )}
      {statisticsData && (
          <div className="card mt-3">
            <div className="card-header text-center">
              <h4 className="mt-2 mb-0">Transfers</h4>
            </div>
            <div className="card-body text-center text-black">
              <h1 className="mt-2 mb-0"
              >{statisticsData.data.transfers}</h1>
            </div>
          </div>
      )}
      {statisticsData && (
       <div className="row">
        <div className="col-12 col-lg-6 d-flex flex-fill">
        {statisticsData && <CustomProviderPractice providerPracticesList={statisticsData?.data?.providers as unknown as ProvidersObject} title={"Providers"} queryParam={queryParams}/>}
        </div>
         <div className="col-12 col-lg-6 d-flex flex-fill">
           {statisticsData && (
               <CustomPieChart pieChartObject={statisticsData.data.mos} title="Cases By Submission Mode"/>
           )}
         </div>
       </div>
      )}
      <div className="row">
        <div className="mt-3">
          {statisticsData && 
            <CaseDetail 
              baseUrl="/territories" searchParams={queryParams} 
              CaseDetailListType={statisticsData.data.case_listing as unknown as CaseListingType[]} 
              forPage="TERRITORY" refreshListing={getStatisticsDataWithLatestParams}
            />
          }
        </div>
      </div>
      <FooterText footerType="black" />
    </div>
  );
};

export default Territory;
